module.exports = __webpack_public_path__ + "static/img/hungry.0b0aabda.png";